<template lang="pug">
  b-container.h-custom
    b-form-row.align-items-center.justify-content-between.mt-3.mb-2
      b-col
        h4 Paquetes de productos
      b-col(md="auto")
        b-button(variant="link", :to="{ name: 'Products' }")
          .d-flex.align-items-center
            arrow-left-icon.icon-md.mr-2
            span Volver a productos
        b-button(variant="an", @click="createPackage", :disabled="creating")
          b-spinner(small, v-if="creating")
          span(v-else) Crear paquete
    b-row
      b-col(lg="4")
        b-nav.overflow-x.flex-nowrap.no-wrap.mb-3.scrollable-area.product-packages(tabs, vertical)
          b-nav-item.mb-3(v-for="productPackage in productsPackages", active-class="custom-nav", :key="productPackage.product_package_id", :to="{name: 'Package', params: { product_package_id: productPackage.product_package_id } }")
            b-avatar.mr-3(:src="productPackage.image", size="lg", rounded, variant="light")
              image-icon(v-if="!productPackage.image", style="width:2rem; height:auto")
            span {{productPackage.name}}
      b-col(lg="8")
        router-view(:key="$route.path", v-if="$route.params.product_package_id && $breakpoint.lgUp")
    .text-center(v-if="loading")
      b-spinner(variant="primary" )
    empty-message(v-else-if="!productsPackages.length", message="No hay paquetes de productos creados" )
    SideModal(v-model="sideModalIsActivated", size="lg", @input="$router.push({ name: 'Products Package' }).then(() => {})")
      template(v-if="sideModalIsActivated")
        router-view(:key="$route.path")
</template>

<script>
import { mapActions, createNamespacedHelpers } from 'vuex'

const productPackageController = createNamespacedHelpers('products_package')

export default {
  data () {
    return {
      sideModalIsActivated: false,
      loading: false,
      creating: false,
      packageFields: [
        {
          key: 'name',
          label: '',
          thStyle: { display: 'none' }
        }
      ]
    }
  },
  computed: {
    ...productPackageController.mapState({
      productsPackages: state => state.product_packages
    })
  },
  methods: {
    ...mapActions([
      'products_package/all',
      'products_package/create',
      'product/all',
      'category/all'
    ]),
    getProducts() {
      const self = this
      const { account_id: accountId } = self.$route.params

      this['product/all']({
        account_id: parseInt(accountId),
        list_all: true,
        params: {page:1, limit: 1000}, // temporal limit
        callback: res => {
          if (res.error) return self.$message.error(res.error)
        }
      })
    },
    getCategories() {
      const self = this

      this["category/all"]({
        account_id: self.$route.params.account_id,
        callback: res => {
          if (res.error) return self.$message.error(res.error)
        }
      })
    },
    getPackages() {
      const self = this
      this.loading = true

      this['products_package/all']({
        account_id: self.$route.params.account_id,
        callback: res => {
          self.loading = false
          if (res.error) return this.$message.error(res.error)

          if(self.productsPackages.length && !self.$route.params.product_package_id) {
            self.$router.push({name: 'Package', params: { product_package_id: self.productsPackages[0].product_package_id } }).catch(() => {})
          }
        }
      })
    },
    createPackage() {
      const self = this
      this.creating = true

      this['products_package/create']({
        account_id: self.$route.params.account_id,
        callback: res => {
          self.creating = false
          if (res.error) return this.$message.error(res.error)

          this.$message.success('Paquete creado con éxito')

          const { product_package_id: productPackageId } = res.resource

          this.$router.push({
            name: 'Package',
            params: { product_package_id: productPackageId }
          }).catch(() => {})
        }
      })
    },
  },
  watch: {
    '$breakpoint' (value) {
      if (value.lgUp) this.sideModalIsActivated = false

      if (
        value.mdDown &&
        this.$route.name === 'Package' &&
        this.$route.params.product_package_id
      ) {
        this.sideModalIsActivated = true
      }
    },
    '$route' (value) {
      this.sideModalIsActivated = value.name === 'Package' && value.params.product_package_id && this.$breakpoint.mdDown
    }
  },
  mounted () {
    this.getProducts()
    this.getCategories()
    this.getPackages()
  }
}
</script>

<style lang="scss">
  .product-packages > .nav-item > .nav-link {
    border-color: transparent;

    &.active, &.router-link-exact-active {
      border-bottom: none !important;
      border-top-right-radius: 0;
      border-bottom-left-radius: 5px;
      border-right: 2px solid #243AE5 !important;
    }
  }
</style>
